import { Lozenge } from "@/components/ui/lozenge"
import { cn } from "@/lib/utils"

// The open-to-work signal: a green lozenge on the top-right of a barber's
// photo. Green means the barber is open to work and to being approached, so a
// shop owner can message or invite them. No dot, no outreach.
//
// Place it inside a `relative` box that wraps the avatar. Not inside the
// Avatar itself, which clips its children to the circle.
export function OpenToWorkDot({ className }: { className?: string }) {
  return (
    <span className={cn("pointer-events-none absolute -right-0.5 -top-0.5 flex", className)} title="Open to work">
      {/* No stroke: a ring in the page colour pinned it to the photo like a
          sticker. Bare, a touch larger, with a soft green glow under it, it
          reads as floating just above the photo. Same 3:4 capsule as every
          other Lozenge. */}
      <Lozenge className="h-3 w-4 bg-booth-green shadow-[0_1px_6px_rgba(16,185,129,0.45)]" />
      <span className="sr-only">Open to work</span>
    </span>
  )
}
